import { createRouteNode } from '@owlsdepartment/vue-tree-routes';

import { Subject } from '@/common/abilities';
import LayoutAdmin from '@/layouts/LayoutAdmin.vue';

const ViewAdminNorms = () => import('@/views/admin/norms/ViewAdminNorms.vue');
const ViewAdminProductNorms = () => import('@/views/admin/norms/ViewAdminProductNorms.vue');

export default createRouteNode({
	shared: {
		basePath: '/norms',
		meta: {
			abilitySubject: Subject.ADMIN_PANEL,
			layout: {
				component: LayoutAdmin,
			},
		},
	},

	routes: [
		{
			name: 'admin-norms',
			path: '/',
			component: ViewAdminNorms,
		},
		{
			name: 'admin-norms-product',
			path: '/:type/:id',
			component: ViewAdminProductNorms,
		},
	],
});
